import ServiceForm from "../component/ServiceForm";

const ServiceCreate = () => {
  return <ServiceForm isEditMode={false} />;
};

export default ServiceCreate;
